import * as React from "react";
import { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import * as Api from "../../General/api";
import * as Common from "../../General/common";

  export default class ResidentStatus extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
        isLoading:false,
        residentStatusList:[],
        resident:props.resident
    }
}
   


componentDidMount() {
    this.getResidentStatus();
}

  getResidentStatus = () => {
    
        Api.getRequestById(Api.Uri_GetLookupValuesByFkId, Common.LookupsFK.Fk_ResidentStatusID)
            .then((res) => {
                
                if (res.data.statusCode == 200) {
                    if (res.data.result != null) {
                        if (res.data.result.length > 0) {
                            this.setState({residentStatusList:res.data.result});
                        }
                    }
                }
            })
            .catch((ex) => {

                Common.LogError(ex, "Resident", "getDropDownValueApiCall");

            });
    }
    //  onChangeResidentStatus = async(e) => {
    
    //     var resident=this.state.resident;
    //     resident.fkResidentStatusId=e.target.value;
    //    await this.setState({resident:resident})
    // }

     setOptionsUI = (options) => {
        return options.map((option) => (
            <option key={option.key} value={option.key}>
                {option.value}
            </option>
        ));
    }
    // const handleResidentActiveInActive =(obj)   => {
    //     if(obj.fkResidentStatusId==Common.ResidentStatusID.open)
    //     {
    //       obj.fkResidentStatusId=Common.ResidentStatusID.closed;
    //     }else{
    //       obj.fkResidentStatusId=Common.ResidentStatusID.open;
    
    //     }
    //    // obj.active=obj.active==true?false:true;
    //     updateResidentActiveInActive(obj);
    //   };
    onSubmit = () => {
        
        var msg="You want to " + (this.state.resident.fkResidentStatusId==Common.ResidentStatusID.open?"Open Resident.":"Change the Resident Status." );
      Common.showConfirmation(msg,"",this.updateActiveInActive,null,this.state.resident)
      
      };
       updateActiveInActive=(obj)=>{
        if(obj){
          Api.postRequest(Api.apiUrls.updateResidentStatus, obj).then((res) => {
            if(res.data.success){
            //   getAllResident();
            this.props.close();
              Common.showSuccessAlertAutoClose("Resident Status Updated Successfully", "success", "Success!", 3000)
            }else{
              Common.showSuccessAlert(res.data.message, "warning", "Warning!", 3000);
            }
          });
        }
      }
      render() {
        return (
        <>
            <div className="row">
                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3">
                    <div className="form-group">
                        <label className="form-label" htmlFor="Status">
                            Resident Status
                        </label>
                        <select
                        className="form-control form-control-sm"
                        id="fkResidentStatusId"
                        name="fkResidentStatusId"
                        required
                        value={Common.replaceNullWithString(
                          this.state.resident.fkResidentStatusId
                        )}
                        onChange={(e) =>
                          Common.updateInputValueInState(
                            this.state.resident,
                            e,
                            this,
                            this.state
                          )
                        }
                      >
                            {this.setOptionsUI(this.state.residentStatusList)}
                        </select>
                    
                    </div>

                </div>
            </div>


        </>
    )

}
 }